import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/ClassFile/webapi.service';

@Component({
  selector: 'app-lab-testing',
  templateUrl: './lab-testing.component.html',
  styleUrls: ['./lab-testing.component.scss']
})
export class LabTestingComponent implements OnInit {

  getLabListArray;

  getSelectLab = "";
  getTestingName = "";
  getDescription = "";
  getPrice = "";
  getAvailability = "";
  getLabPrice = "";

  constructor(private toastr: ToastrService,private webApiService: WebapiService,) {
    this.ViewList();
  }

  ngOnInit(): void {
  }

  ViewList(){


    this.webApiService.getLabData().subscribe((res => {

        if(res == ""){
          this.toastr.error("Empty Data", "NO Data Found");
        }else{
          this.getLabListArray = res;
          //console.log(this.getLabListArray);
        }

    }), (err) => {
        this.toastr.error(err.error.Error, 'Error!');
    })

  }

  Validation(){

    if(this.getSelectLab == "" || this.getTestingName == "" || this.getPrice == "" || this.getAvailability == ""){
      this.toastr.error("Empty Field Found", "Error");
    }else{
      this.Save();
    }




  }

  Save(){

    const labData = {
      labID: this.getSelectLab,
      name: this.getTestingName,
      description: this.getDescription,
      unitPrice: this.getPrice,
      customAvailable: this.getAvailability,
      labPrice: this.getLabPrice,
      addedBy: 'admin'
  };

    this.webApiService.saveTestingData(labData).subscribe((res) => {

        console.log(res);
        this.toastr.success("Insert Success", 'Success!');
        // let response = JSON.stringify(res);
        // let e_data = JSON.parse(response).Data;
        // let e_code = JSON.parse(response).Code;

        // if(e_code == "S100"){
        //   this.toastr.success(e_data, 'Info!');
        //   this.router.navigate(['/Login']);
        // }else if(e_code == "E100"){
        //   this.toastr.error(e_data, "Error!");
        // }else{
        //   this.toastr.error('Something went wrong Please try Again', 'Error!');
        // }

    }), (err) => {
      console.log(err);

        this.toastr.error('Something went wrong Please try Again', 'Error!');
    }







  }

}
